/*global module */

window.auguste = window.auguste || {};
window.auguste.PasswordViewer = (function () {
    const PasswordViewer = {
        toggle_password_visibility : ( input ) => {
            input.type = input.type === "password" ? "text" : "password";
        },

        add_password_viewer_icon : ( input ) => {
            if ( input.getAttribute( 'data-password-viewer-added' ) ) {
                return;
            }

            input.setAttribute( 'data-password-viewer-added', true );

            const icon = document.createElement( 'span' );
            icon.classList.add( 'icon' );
            icon.setAttribute( 'data-password-viewer', 'true' );

            const eye = document.createElement( 'i' );
            eye.classList.add( 'fa-solid', 'fa-eye' );
            eye.addEventListener( 'click', () => PasswordViewer.toggle_password_visibility( input ) );
            eye.setAttribute( 'tabindex', '0' );

            const eye_slash = document.createElement( 'i' );
            eye_slash.classList.add( 'fa-solid', 'fa-eye-slash' );
            eye_slash.addEventListener( 'click', () => PasswordViewer.toggle_password_visibility( input ) );
            eye_slash.setAttribute( 'tabindex', '0' );

            icon.appendChild( eye );
            icon.appendChild( eye_slash );
            input.after( icon );
        },

        handle_password_viewer_inputs : () => {
            const input_fields = document.querySelectorAll( 'input[data-password-viewable]:not([data-password-viewer-added="true"])' );
            input_fields.forEach( PasswordViewer.add_password_viewer_icon );
        }
    };
    PasswordViewer.handle_password_viewer_inputs();
    return PasswordViewer;
}());

if (typeof module !== 'undefined') {
    module.exports.PasswordViewer = window.auguste.PasswordViewer;
}
